import React, { useEffect } from "react";
//outsource
import { Row, Col, Grid } from "antd";

//components

const { useBreakpoint } = Grid;

const BreakpointNumCol = ({ setMobile }) => {
  // -------------------------- VAR --------------------------
  const screens = useBreakpoint();
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (screens?.xs) {
      setMobile(1);
    }
    if (screens?.sm) {
      setMobile(2);
    }
    if (screens?.md) {
      setMobile(2);
    }
    if (screens?.lg) {
      setMobile(3);
    }
    if (screens?.xl) {
      setMobile(4);
    }
    if (screens?.xxl) {
      setMobile(5);
    }
  }, [screens]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return <></>;
};

export default BreakpointNumCol;
